import Icon from '@dtvgo/icon';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import './PlayPauseButton.scss';
import { jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';

/* External */

function PlayPauseButton(_ref) {
  var handleTogglePlayPause = _ref.handleTogglePlayPause,
    isPlaying = _ref.isPlaying,
    tooltipPause = _ref.tooltipPause,
    tooltipPlay = _ref.tooltipPlay,
    className = _ref.className;
  return /*#__PURE__*/jsx(PlayerButton, {
    className: "dtv-common-c-play-pause-button ".concat(className),
    onClick: handleTogglePlayPause,
    tooltip: isPlaying ? tooltipPause : tooltipPlay,
    children: /*#__PURE__*/jsx(Icon, {
      name: isPlaying ? 'pause' : 'play'
    })
  });
}
PlayPauseButton.defaultProps = {
  handleTogglePlayPause: function handleTogglePlayPause() {},
  isPlaying: false,
  tooltipPause: '',
  tooltipPlay: '',
  className: ''
};

export { PlayPauseButton as default };
//# sourceMappingURL=PlayPauseButton.js.map
